export const CONTENT_TEAM_ASSIGNMENT = 'content-team-assignment';
export const TEAMS_CONTENT_PARTITIONING = 'teams-content-partitioning';